import { redirect } from "react-router"
import type { LoaderFunctionArgs } from "react-router"

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { authPayload } = await window.domain.GetAuthPayloadAuthUseCase.execute()

  if (!authPayload) {
    const { pathname, search, hash } = new URL(request.url)
    if (pathname !== "/" && pathname !== "/login" && pathname !== "/register") {
      if (pathname.startsWith("/") && !pathname.startsWith("//")) {
        sessionStorage.setItem("returnTo", pathname + search + hash)
      }
    }
    return redirect("/login")
  }

  return null
}
